<template>
    <div class="cs-planlist-container">
        <el-row>
            <el-col :span="12">
                <span class="cs-title">方案列表</span>
            </el-col>
            <el-col :span="12" class="text-right">
                <el-button v-if="!USERMANAGER.isSales && !USERMANAGER.isReceptionist && !USERMANAGER.isAssistant" type="primary" icon="el-icon-plus" size="medium" @click="addPlan" :loading="isAdding">添加方案</el-button>
            </el-col>
        </el-row>
          <el-alert :title="this.errorMessage" v-show="this.isShowError"  type="error">
        </el-alert>
        <el-row class="cs-filter-row">
            <el-col>
                <el-table ref="planTable" @expand-change="expandChange" :data="speedupCoursePlans" class="plan-list" :cell-class-name="'plan-list-cell'" :header-row-class-name="'el-table-header'" :show-header="false">
                    <el-table-column type="expand" min-width="5%">
                        <template slot-scope="scope">
                            <el-row v-for="(item, index) in scope.row.courseList" @click.native="selectCourse(item)" :key="index" 
                            :class="{'cs-expand-content':true, 'course-border-top':hasBorderTop(scope.row.courseList, index), 'active':checkAcitve(item)}">
                                <el-col :span="8">
                                    <span v-text="getCourseName(item)"></span>
                                </el-col>
                                 <el-col :span="1">
                                     &nbsp;
                                </el-col>
                                <el-col :span="13">
                                    <span v-text="getScheduleDescription(item)"></span>
                                </el-col>
                                <el-col :span="2" class="text-right">
                                   <i v-if="!USERMANAGER.isSales && !USERMANAGER.isReceptionist && !USERMANAGER.isAssistant" class="el-icon-close btn-close" @click="deleteCourseSchedule(item)"></i>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Name" label="方案名称" min-width="30%" >
                         <template slot-scope="scope">
                            <div>
                                <strong><label v-text="scope.row.Name"></label></strong>
                                <span class="selectedPlan" v-if="scope.row.Selected">(选中)</span>
                            </div>
                        </template>
                    </el-table-column>
                     <el-table-column min-width="30%">
                        <template slot-scope="scope">
                            <div class="plan-list-item-container">
                                <el-button type="text" size="mini" @click="preview(scope.row)">预览</el-button>
                                <el-button v-if="!USERMANAGER.isSales && !USERMANAGER.isReceptionist && !USERMANAGER.isAssistant" type="text" size="mini" class="delete" @click="deletePlan(scope.row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                     <el-table-column min-width="40%">
                        <template slot-scope="scope">
                            <div  class="plan-list-item-container">
                                <span>已添加：</span>
                                <span>{{getScheduledCourseCount(scope.row)}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
            <el-dialog class="cs-previewCourse" :title="preivewPlan.Name+'预览'" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="preivewPlanDialogVisible" top="5vh">
              <schedule-plan-preview :termId="termId" :plan="preivewPlan" :totalCourseCount="totalCourseCount"></schedule-plan-preview>
            </el-dialog>
    </div>
</template>

<style lang="scss">
.cs-planlist-container {
  .cs-title {
    margin-left: 30px;
  }
  .delete {
    color: red;
  }
  .selectedPlan{
    color: red;
  }
  .plan-list {
    font-size: 13px;

    .plan-list-item-container{
      display: flex;
      flex-wrap: wrap;
      button{
        margin: 0;
        flex: 1;
      }
      label{
        margin: 0;
        flex: 1;
        display: block;
        width: 100%;
      }
    }
  }

  .cs-expand-content {
    text-align: left;
    .el-icon-close {
      color: red;
      cursor: pointer;
    }
    span {
      display: block;
    }
  }
  .el-table {
    tr {
      background-color: transparent;
      .el-table__expanded-cell {
         background-color: transparent;
        // padding: 5px 10px;
        padding:0;
        &:hover{
          opacity:1.0;

          box-shadow:none;
        }

        .cs-expand-content{
          padding: 5px;
          cursor: pointer;

          &.active{
            background-color: #59c2e6;
          }
        }
      }
    }
  }

  .course-border-top {
    border-top: 1px solid #ced3d9;
  }
}
.cs-previewCourse {
  .el-dialog {
    .el-dialog__body {
      padding-bottom: 0;
    }
  }
}
</style>

<script>
import {
  addSpeedupCourseSchedulePlan,
  removeSpeedupPlan,
  deleteSpeedupCourse
} from "../../service/speedupCourse.service";
import schedulePlanPreview from "../speedupCourse/schedulePlanPreview";
import { srcTimesOfDay, srcDaysOfWeek } from "../../service/api-base.service";
import { formatTimeToInt60 } from "../../config/mUtils";
export default {
  data() {
    return {
      isAdding: false,
      isShowError: false,
      errorMessage: "",
      scheduledCourseCount: 0,
      speedupCoursePlans: [],
      daysOfWeekList: srcDaysOfWeek(),
      selectedCourseList: [],
      expandId: 0,
      preivewPlan: {},
      preivewPlanDialogVisible: false,
      selectedCourse: null
    };
  },
  created() {
    this.loadSpeedupCoursePlan();
  },
  props: {
    courseType:Number,
    termId :[String, Number],
    plans: Array,
    totalCourseCount: Number,
    universityGroupNumber:[String, Number],
    campusId:[String, Number],
  },
  components: {
    schedulePlanPreview
  },
  methods: {
    checkAcitve(item){
      // if (!!this.selectedCourse && this.selectedCourse.CourseId == item.CourseId && 
      // this.selectedCourse.TeacherId == item.TeacherId && this.selectedCourse.CourseClass == item.CourseClass){
      //   return true;
      // }
      if (!!this.selectedCourse && this.selectedCourse.ScheduleId == item.ScheduleId){
        return true;
      }
      return false;
    },
    selectCourse(item){
      this.selectedCourse = item;
      this.$emit("selectCourse", item);
      //console.log(this.selectedCourse);
    },
    getCourseName(item) {
      let courseName = item.CourseName;
      if (item.CourseClass > 0) {
        courseName += "-分班" + item.CourseClass;
      }
      return courseName;
    },
    getScheduledCourseCount(plan) {
      if (!!plan.courseList) {
        return plan.courseList.length;
      }
      if(!plan.ScheduledCourseCount){
        return 0;
      }
      return plan.ScheduledCourseCount;
    },
    hasBorderTop(courseList, index) {
      if (index > 0) {
        let coursePre = courseList[index - 1];
        let courseCurrent = courseList[index];
        if (
          coursePre.DayOfWeek != courseCurrent.DayOfWeek ||
          coursePre.StartTimeText != courseCurrent.StartTimeText ||
          coursePre.EndTimeText != courseCurrent.EndTimeText
        ) {
          return true;
        }
      }
      return false;
    },
    deletePlan(rowData) {
      if (rowData) {
        let name = rowData.Name;
        let id = rowData.Id;
        this.$confirm("您是否要删除" + name + "?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            removeSpeedupPlan(id).then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });

                this.$emit("deletePlan", id);
              } else {
                if (result.message) {
                  this.$message({
                    type: "warning",
                    message: result.message
                  });
                }
              }
            });
          })
          .catch(() => {});
      }
    },
    getScheduleDescription(item) {
      let daysOfWeek = item.DayOfWeek;
      if (daysOfWeek == 0) {
        daysOfWeek = 7;
      }
      let daysOfWeekText = this.daysOfWeekList[daysOfWeek - 1].label;
      let desc =
        daysOfWeekText + " " + item.StartTimeText + "-" + item.EndTimeText;
      return desc;
    },
    expandChange(row, expandedRows) {
      if (expandedRows.length > 1) {
        expandedRows.shift();
      }
      if (expandedRows.length > 0) {
        if (!row.courseList) {
          this.expandId = row.Id;
          this.$emit("loadDetail", row.Id);
        } else {
        }
      }
    },
    loadSpeedupCoursePlan() {
      //console.log("loadSpeedupCoursePlan");
      this.speedupCoursePlans = this.plans;
      if (!!this.expandId) {
        if (this.speedupCoursePlans.length > 0) {
          let rows = this.speedupCoursePlans.filter(i => i.Id == this.expandId);
          if (rows && rows.length > 0) {
            this.$refs.planTable.toggleRowExpansion(rows[0]);
          }
        }
      }

      //   if (this.expandId){
      //      let selectedPlan = this.speedupCoursePlans.filter(i => i.Id == this.expandId);
      //      if (selectedPlan && selectedPlan.length > 0){
      //          this.selectedCourseList = selectedPlan.courseList;
      //      }
      //   }

    },
    addPlan() {
      this.isAdding = true;
      let groupNumber = this.universityGroupNumber;
      let campusId = this.campusId;
      if (this.courseType == 3 || this.courseType == 2){
        groupNumber = null;
      }
      if (this.courseType != 3){
        campusId = null;
      }
      addSpeedupCourseSchedulePlan(this.termId, groupNumber, campusId).then(result => {
        if (!!result && result.success) {
          //this.loadSpeedupCoursePlan();
          this.isShowError = false;
          this.errorMessage = "";

          this.$emit("addPlan", result.data);
        } else {
          this.isShowError = true;
          this.errorMessage = result.message;
        }
        this.isAdding = false;
      });
    },
    deleteCourseSchedule(item) {
      this.$confirm("您是否要删除该课程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteSpeedupCourse(
            item.ScheduleId
          ).then(result => {
            if (result.success) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });

              this.$emit("deleteCourse", item);
            } else {
              if (result.message) {
                this.$message({
                  type: "warning",
                  message: result.message
                });
              }
            }
          });
        })
        .catch(() => {});
    },
    showPreview(plan) {
      this.preivewPlanDialogVisible = true;
      this.preivewPlan = plan;
    },
    preview(plan) {
      if (!plan.courseList) {
        this.$emit("loadDetail", plan.Id, this.showPreview);
      } else {
        this.showPreview(plan);
      }
    }
  },
  watch: {
    plans: function() {
      this.loadSpeedupCoursePlan();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCoursePlanList.vue